import React, { PureComponent } from "react";
import Logo from "./assets/LandingPageLogo2.png";
import LogoMobile from "./assets/LandingPageLogo.png";
import ScreenPreview from "./assets/Screenshot.png";
import { changeLocation } from "api/Location";

import { batchRequest, getRequest, postRequest } from "../api/ApiService";
import Auth from "../routes/Auth";
import Teams, { teamsEndpoint } from "../api/Teams";
import EventEmitter from "../services/event-emitter";
import { detectMobile, getLogoStyle } from "services/utils";

class JoinPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      team: 0,
      role: "",
      showError: false,
      teams: [],
      players: [],
      roles: {
        CEO: "CEO",
        PD: "Product Management",
        PM: "Product Marketing",
        OP: "Operations",
        FI: "Finance"
      }
    };

    this.eventemitter = EventEmitter.getInstance();
    this.isMobile = detectMobile();
  }

  componentDidMount() {
    const game_id = Auth.getGameId();

    batchRequest([
      `${process.env.REACT_APP_API_URL}games/${game_id}/`,
      teamsEndpoint()
    ])
      .then(res => {
        const res1 = res[0].body;
        const res2 = res[1].body;
        const teams = res2.filter(i => res1.teams.includes(i.id));

        this.setState({
          teams
        });
      })
      .catch(err => {});
  }

  handleInputChange = e => {
    const id = e.target.id;
    let value = e.target.value;

    if (id === "team") {
      value = parseInt(value, 10);
      if (isNaN(value)) {
        value = 0;
      }
    }

    this.setState(
      {
        [id]: value
      },
      () => {
        if (id === "team") {
          this.updatePlayers();
        }
      }
    );
  };

  updatePlayers = () => {
    const { team } = this.state;

    getRequest(`${process.env.REACT_APP_API_URL}teams/${team}/players/`)
      .then(res => {
        const players = res.body.filter(i => !("user" in i) || !i.user);

        this.setState({
          players,
          role: ""
        });
      })
      .catch(err => {});
  };

  handleSubmit = () => {
    const { team, role } = this.state;
    const game_id = Auth.getGameId();

    this.setState({
      showError: false
    });

    postRequest(`${process.env.REACT_APP_API_URL}games/${game_id}/join_team/`)
      .send({ team, role })
      .then(res => {
        getRequest(Auth.getUserDataRequest())
          .then(res2 => {
            Auth.setUserData(res2.body);

            batchRequest([...Teams.requests()])
              .then(res3 => {
                const teams_data = [
                  {
                    status: res3[0].statusCode,
                    data: res3[0].body
                  },
                  {
                    status: res3[1].statusCode,
                    data: res3[1].body
                  }
                ];
                Teams.setData(teams_data);

                this.eventemitter.trigger("reload-data");
                changeLocation(`/start`);
              })
              .catch(err => {});
          })
          .catch(err => {});
      })
      .catch(err => {
        this.setState({
          showError: true
        });
      });
  };

  onSubmit = e => {
    e.preventDefault();
  };

  logout = e => {
    e.preventDefault();

    if (Auth.isUserAuthenticated()) {
      Auth.deauthenticateUser();
      window.location.reload();
    }
  };

  render() {
    const { team, role, showError, teams, players, roles } = this.state;
    const logoStyle = getLogoStyle(this.isMobile);
    const LogoImg = this.isMobile ? (
      <img src={LogoMobile} style={logoStyle} alt="Logo" />
    ) : (
      <img src={Logo} className="join-page-logo" alt="Logo" />
    );
    const logoClass = this.isMobile
      ? "text-center mg-top-15vh"
      : "text-center mg-top-10vh";
    const formClass = this.isMobile ? "mg-top-5vh" : "mg-top-10vh";

    return (
      <div className="container-fluid bg-color-blue height-100vh">
        <div className="row">
          <div className="col-md-4 col-xs-12">
            <div className={logoClass}>{LogoImg}</div>
            <div className={formClass}>
              <form className="form-signin" onSubmit={this.onSubmit}>
                {showError === true && (
                  <div className="col-md-10 col-md-offset-1 alert alert-danger col-xs-12">
                    Select valid Team & Role
                  </div>
                )}
                <div className="form-group col-md-10 col-md-offset-1 mg-top-5vh col-xs-12">
                  <label
                    htmlFor="team"
                    className="control-label font-size-14 color-white"
                  >
                    Join a Team
                  </label>
                  <select
                    id="team"
                    value={team}
                    onChange={this.handleInputChange}
                    className="join-select-input"
                  >
                    <option value="0">Join a Team</option>
                    {Object.keys(teams).map(i => {
                      const team = teams[i];
                      return (
                        <option key={i} value={team.id}>
                          {team.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="form-group col-md-10 col-md-offset-1 mg-top-2vh col-xs-12">
                  <label
                    htmlFor="role"
                    className="control-label font-size-14 color-white"
                  >
                    Select a Role
                  </label>
                  <select
                    id="role"
                    value={role}
                    onChange={this.handleInputChange}
                    className="join-select-input"
                  >
                    <option value="">Select a Role</option>
                    {Object.keys(players).map(i => {
                      const player = players[i];

                      return (
                        <option key={i} value={player.role}>
                          {roles[player.role]}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="col-md-10 col-md-offset-1 mg-top-3vh col-xs-12">
                  <button
                    type="submit"
                    onClick={this.handleSubmit}
                    className="btn login-btn btn-lg btn-block"
                  >
                    Let's Play!
                  </button>
                </div>
                <div className="col-md-10 col-md-offset-1 logout-btn col-xs-12">
                  <a href="/#" className="btn btn-link" onClick={this.logout}>
                    Logout
                  </a>
                </div>
              </form>
            </div>
          </div>
          <div className="col-md-8 color-white hidden-xs">
            <div className="text-center mg-top-10vh join-page-caption">
              Will you be the Market Leader?
            </div>
            <div className="col-md-12">
              <img
                src={ScreenPreview}
                className="join-page-screen-preview"
                alt="Screen Preview"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default JoinPage;



// WEBPACK FOOTER //
// ./src/containers/join-page.js